
export default {
	name: 'fillColor',
	handler: {
		update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
			let color = '';
			let value = valueAccessor();
			// let allBindings = allBindingsAccessor();

			let valueUnwrapped = ko.utils.unwrapObservable(value);

			if (valueUnwrapped)
			{
				color = getColorToGlobalPos(valueUnwrapped);
				color = 'color' + color;
				$(element).addClass(color);
			}
		}
	}
};
